<app-page-layout>
  <section class="contact-page">
    <div
      class="contact-shell observatory-pattern-surface observatory-pattern-subtle"
      [class.observatory-pattern-off]="!usePatternedContactShell"
    >
      <div class="contact-header">
        <h1>Contact</h1>
        <!-- <p>Send a message to the MAQI team.</p> -->
      </div>

      <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
        <mat-card class="contact-card">
          <div class="name-email-wrapper">
            <mat-form-field appearance="outline">
              <mat-label>Name</mat-label>
              <input matInput formControlName="name" autocomplete="name" />
              @if (form.controls.name.hasError('required')) {
              <mat-error>Name is required</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" type="email" autocomplete="email" />
              @if (form.controls.email.hasError('required')) {
              <mat-error>Email is required</mat-error>
              } @else if (form.controls.email.hasError('email')) {
              <mat-error>Email should be valid</mat-error>
              }
            </mat-form-field>
          </div>

          <mat-form-field class="message-field" appearance="outline">
            <mat-label>Message</mat-label>
            <textarea
              matInput
              formControlName="message"
              minlength="10"
              maxlength="1000"
              rows="9"
            ></textarea>
            <mat-hint align="end">{{ form.controls.message.value.length || 0 }} / 1000</mat-hint>
            @if (form.controls.message.hasError('required')) {
            <mat-error>Message is required</mat-error>
            } @else if (form.controls.message.hasError('minlength')) {
            <mat-error>Message must be at least 10 characters</mat-error>
            } @else if (form.controls.message.hasError('maxlength')) {
            <mat-error>Message must be less than 1000 characters</mat-error>
            }
          </mat-form-field>

          <div class="contact-actions">
            <div class="captcha-wrapper">
              @if (isLocalCaptchaMode) {
              <div class="debug-captcha-panel" [class.captcha-passed]="isMessageSendable">
                <span>Local captcha check</span>
                <button type="button" (click)="passLocalCaptcha()" [disabled]="isMessageSendable">
                  {{ isMessageSendable ? 'Captcha passed' : 'Pass captcha' }}
                </button>
              </div>
              } @else { @if (isCaptchaLoading) {
              <div class="captcha-loading" role="status" aria-live="polite">Loading captcha...</div>
              }
              @if (captchaErrorMessage) {
              <div class="captcha-error" role="alert">{{ captchaErrorMessage }}</div>
              }
              <div [id]="captchaContainerId"></div>
              }
            </div>

            <button
              mat-flat-button
              type="submit"
              class="send-button"
              [disabled]="!isFormSubmittable() || isSubmitting"
            >
              <mat-icon>{{ isSubmitting ? 'hourglass_empty' : 'send' }}</mat-icon>
              {{ isSubmitting ? 'Sending...' : 'Send' }}
            </button>
          </div>
        </mat-card>
      </form>
    </div>
  </section>
</app-page-layout>
